
import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare var $: any;
import { debounceTime } from "rxjs/operators";
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { password_validation } from '../../shared/constants';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-appointment-list',
	templateUrl: './appointment-list.component.html',
	styleUrl: './appointment-list.component.scss'
})
export class AppointmentListComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	dataList: any = [];
	allFlagStates: any[] = [];
	flagState: any = null;
	apptModuleAccess: any = "Full";
	accessLoader = false;
	companyList: any[] = [];
	/* vesselList: any[] = [];
	branchList: any[] = []; */
	filters: any = {
		company: null,
		branch: null,
		vessel: null,
		fromDate: null,
		toDate: null
	};
	pdfDownloadLoader1: any = null;
	pdfDownloadLoader2: any = null;
	detailsLoader: any = null;
	excelLoader = false;
	showIsDoneLoader: any = null;
	deleteLoader: any = null;

	constructor(private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.initDatatable();
		this.getCompanyList();
	}

	ngOnDestroy(): void {

	}

	ngAfterViewInit(): void {

	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length
				}
				if (dataTablesParameters.search.value != "") {
					data.search = dataTablesParameters.search.value;
				}
				if (this.filters.company) {
					data["company"] = this.filters.company;
				}
				if (this.filters.branch) {
					data["branch"] = this.filters.branch;
				}
				if (this.filters.vessel) {
					data["vessel"] = this.filters.vessel;
				}
				if (this.filters.fromDate) {
					data["fromDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.filters.fromDate);
				}
				if (this.filters.toDate) {
					data["toDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.filters.toDate);
				}
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				this.http.get<DataTablesResponse>(this.baseURL + "appt_list", { params: new HttpParams(httpParams) }).subscribe({
					next: (response: any) => {
						for (let i = 0; i < response.data.length; i++) {
							response.data[i].status = response.data[i].status ? true : false;
							response.data[i].status_temp = response.data[i].status;
						}
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	getCompanyList() {
		this.apiService.getAllCompanyList().subscribe({
			next: (data: any) => {
				this.companyList = data;
			}, error: (error) => {
				this.companyList = [];
				if (error.status == 401) { return }
			}
		});
	}

	/* getVesselListByCompany(clearVessel: boolean) {
		if (clearVessel) {
			this.filters.vessel = null;
		}
		if (this.filters.company) {
			this.apiService.getVesselListByCompany({ company: this.filters.company }).subscribe({
				next: (data: any) => {
					this.vesselList = data;
				}, error: (error) => {
					this.vesselList = [];
				}
			});
		} else {
			this.vesselList = [];
		}
	}

	getBranchListByCompany(clearBranch: boolean) {
		if (clearBranch) {
			this.filters.branch = null;
		}
		if (this.filters.company) {
			this.apiService.getBranchListByCompany({ company: this.filters.company }).subscribe({
				next: (data: any) => {
					this.branchList = data;
				}, error: (error) => {
					this.branchList = [];
				}
			});
		} else {
			this.branchList = [];
		}
	} */

	/* createTrainingCertificate(index: number) {
		if(!this.dataList[index].zip_url){
			Swal.fire({
				title: 'Please wait',
				html: 'Cartificates are being generated. Please try after some time.',
				icon: 'info'
			});
			return;
		}
		this.pdfDownloadLoader1 = index;
		this.apiService.getCertificateZip(this.dataList[index].zip_url).subscribe({
			next: (res) => {
				this.pdfDownloadLoader1 = null;
				let zipData: any = res.body;
				let blob = new Blob([zipData], { type: "application/zip" });
				let fileName = this.dataList[index].company + "_" + this.dataList[index].DOE + ".zip";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfDownloadLoader1 = null;
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	createTrainingCertificateOld(index: number) {
		this.pdfDownloadLoader1 = index;
		let ids: any = [];
		for (let i = 0; i < this.dataList[index].appt_list.length; i++) {
			ids.push(this.dataList[index].appt_list[i].id1);
		}
		this.apiService.saveMultipleCertificate({ Ids: ids }).subscribe({
			next: (res) => {
				this.pdfDownloadLoader1 = null;
				let zipData: any = res.body;
				let blob = new Blob([zipData], { type: "application/zip" });
				let fileName = this.dataList[index].company + "_" + this.dataList[index].DOE + ".zip";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfDownloadLoader1 = null;
				if (error.status == 400) {
					const decodedString = String.fromCharCode(...new Uint8Array(error.error));
					this.toastr.error(decodedString, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				} else {
					this.toastr.error("Unable to download file", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			}
		});
	} */

	deleteConfirm(ref_no: any, index: number) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.deleteLoader = index;
				this.apiService.deleteCase(ref_no).subscribe({
					next: (response: any) => {
						this.deleteLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.deleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 400) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	downloadExcel() {
		this.excelLoader = true;
		let data: any = {
		}
		if (this.filters.company) {
			data["company"] = this.filters.company;
		}
		if (this.filters.branch) {
			data["branch"] = this.filters.branch;
		}
		if (this.filters.vessel) {
			data["vessel"] = this.filters.vessel;
		}
		if (this.filters.fromDate) {
			data["fromDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.filters.fromDate);
		}
		if (this.filters.toDate) {
			data["toDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.filters.toDate);
		}
		this.apiService.appoinmentListExcel(data).subscribe({
			next: (res: any) => {
				this.excelLoader = false;
				let fileData: any = res.body;
				let blob = new Blob([fileData], { type: "application/ms-excel" });
				let fileName = "Training.xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.excelLoader = false;
				if (error.status == 400) {
					const decodedString = String.fromCharCode(...new Uint8Array(error.error));
					this.toastr.error(decodedString, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				} else {
					this.toastr.error("Unable to download file", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			}
		});
	}

	participants: any[] = [];
	selectedRefNo: any = null;
	selectAll = false;
	getApptDetails(index: number) {
		this.detailsLoader = index;
		this.apiService.getApptDetails(this.dataList[index].ref_no).subscribe({
			next: (data: any) => {
				this.detailsLoader = null;
				/* if (data.length == 1 && data[0].f_name == null && data[0].l_name == null) {
					this.toastr.warning("There are no participants in this training.", 'No Participants', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				} else {
					this.participants = data;
					$("#apptDetailsModal").modal("show");
				} */
				this.selectAll = false;
				this.selectedRefNo = this.dataList[index].ref_no;
				this.participants = data;
				$("#apptDetailsModal").modal("show");
			}, error: (error) => {
				this.detailsLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	check_uncheck_all() {
		const len = this.participants.length;
		for (let i = 0; i < len; i++) {
			this.participants[i].selected = this.selectAll;
		}
	}

	check_uncheck_single() {
		const len = this.participants.length;
		let selectAll = true;
		for (let i = 0; i < len; i++) {
			if (!this.participants[i].selected) {
				selectAll = false;
			}
		}
		this.selectAll = selectAll;
	}

	gotoQueAns() {
		let idList = [this.selectedRefNo];
		const len = this.participants.length;
		for (let i = 0; i < len; i++) {
			if (this.participants[i].selected) {
				idList.push(this.participants[i].id);
			}
		}
		if (idList.length > 1) {
			$("#apptDetailsModal").modal("hide");
			this.router.navigate(['/app/userans', idList.join("__")]);
		} else {
			this.toastr.error('Please select candidate', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	clearApptDetailsModal() {
		$("#apptDetailsModal").modal("hide");
		this.detailsLoader = null;
		this.participants = [];
		this.selectedRefNo = null;
		this.selectAll = false;
	}

	createSingleCertificate(index: number) {
		this.pdfDownloadLoader2 = this.participants[index].id;
		this.apiService.createCertificate(this.participants[index].id).subscribe({
			next: (res: any) => {
				let pdfData: any = res.body;
				this.pdfDownloadLoader2 = null;
				let blob = new Blob([pdfData], { type: "application/pdf" });
				let fileName = this.participants[index].f_name + " " + this.participants[index].l_name + ".pdf";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfDownloadLoader2 = null;
				if (error.status == 400) {
					const decodedString = String.fromCharCode(...new Uint8Array(error.error));
					this.toastr.error(decodedString, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				} else {
					this.toastr.error("Unable to download file", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			}
		});
	}

	changeTrainingDone(po: any, index: number) {
		let statusStr = "";
		if (po.status) {
			statusStr = "Done";
		} else {
			statusStr = "Not Done";
		}
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to change status to <strong>' + statusStr + '</strong>?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Continue',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.showIsDoneLoader = index;
				this.apiService.doneNotDone({ ref_no: po.ref_no, status: po.status ? 1 : 0 }).subscribe({
					next: data => {
						this.showIsDoneLoader = null;
						this.dataList[index].status_temp = po.status;
						Swal.fire('Success', 'Updated successfully.', 'success');
					}, error: (error) => {
						this.showIsDoneLoader = null;
						if (error.status == 401) { return }
						Swal.fire('Error', "Something went wrong", 'error');
						po.status = po.status_temp;
					}
				});
			} else {
				po.status = po.status_temp;
			}
		})
	}

	getParticipantText() {
		try {
			let count = this.participants[0].numberOfCandidate || this.participants.length;
			return count > 1 ? count + ' Participants' : count + ' Participant';
		} catch (error) {
			return "";
		}
	}
}
